import { useState, useContext, useEffect, useRef } from "react"
import { BtnLoader, CSelect, toast, CInputText, CInputPassword, CToggle, CModal } from "../../../components/widget"
import { ContextNav, ContextDashboard, ContextLoading } from "../../../context";
import { OperationEditApi, SingleOperationApi } from "../../../api";
import { useNavigate } from "react-router-dom";
import { useParams, Link } from "react-router-dom";

export const OperationsEdit = () => {
    const navigate = useNavigate()
    const formRef: any = useRef()
    const CtxNav = useContext(ContextNav)
    const CtxLoad = useContext(ContextLoading)
    let params = useParams();
    const [singleData, setSingleData] = useState<any>(null)
    const [listGroup, setListGroup] = useState<any>([])


    const onFinish = async (e: any) => {
        e.preventDefault()
        CtxLoad.setDisplayLoadingBtn(true)
        let res = await OperationEditApi(formRef, singleData)
        CtxLoad.setDisplayLoadingBtn(false)
        if (res.success) {
            toast('ویرایش موفقیت آمیز بود', { type: "success" })
            navigate('/p/settings/operations');
        }
        else {
            toast(res.message, { type: "error" })
        }
    }


    const getData = async () => {
        CtxLoad.setDisplayLoadingBlur(true)
        let res = await SingleOperationApi(params.id)
        if (res.success) {
            setSingleData(res.data)
            formRef.current['action'].value = res.data.action;
            // formRef.current['group'].value = res.data.job_group_id;
            CtxLoad.setDisplayLoadingBlur(false)
        }
        else {
            CtxLoad.setDisplayLoadingBlur(false)
        }
    }


    useEffect(() => {
        document.title = "ویرایش عملیات | دایان"
        CtxNav.setActiveMenuItem({ 'item': 3, 'subItem': 8, })
        getData()
    }, [])

    return (
        <div className=" w-full flex flex-col">
            <h1 className="sm:text-2xl text-lg font-bold mb-[30px]">ویرایش عملیات خودکار</h1>

            <form ref={formRef} onSubmit={onFinish} className=" w-full  flex flex-col shadow sm:rounded-xl rounded-lg bg-white py-[15px] sm:py-[30px] sm:px-[20px] px-[10px]">


                <div className=" w-full flex flex-col md:flex-row items-center mt-[15px] sm:mt-[40px] border-b pb-[15px] sm:pb-[30px]">
                    <div className=" w-full md:w-[33.33%]  flex flex-col sm:flex-row items-center">
                        <div className=" w-full  h-[50px] flex md:mt-0 mt-5 items-center pl-0 sm:pl-2 relative">
                            <div className=" w-full h-[50px] pl-1 sm:pl-2">
                                <CSelect name="action" placeholder={'انتخاب عملیات'} title="عملیات" border={true} required={true}>
                                    <option value={1}>تایید خودکار</option>
                                    <option value={2}>رد خودکار</option>
                                </CSelect>
                            </div>
                        </div>
                    </div>
                    <div className="  w-full md:w-[33.33%] flex flex-col sm:flex-row items-center">
                        <div className=" w-full  h-[50px] flex md:mt-0 mt-5 items-center pl-0 sm:pl-2 relative">
                            <div className=" w-full h-[50px] pl-1 sm:pl-2">
                                <CSelect name="period" placeholder={'انتخاب بازه'} title="بازه زمانی" border={true} required={true}>
                                    <option value={1}>5 دقیقه</option>
                                    <option value={2}>30 دقیقه</option>
                                    <option value={3}>1 ساعت</option>
                                    <option value={4}>8 ساعت</option>
                                    <option value={5}>1 روز</option>
                                    <option value={6}>7 روز</option>
                                    <option value={7}>15 روز</option>
                                    <option value={8}>30 روز</option>
                                </CSelect>
                            </div>
                        </div>
                    </div>
                </div>

                <div className=" w-full mt-[40px] flex items-center">
                    {CtxLoad.displayLoadingBtn ?
                        <button type="button" className="w-[100px] h-[40px] bg-dayan-gray-200 text-white rounded-[5px] text-sm shadow cursor-not-allowed relative flex justify-center items-center"><BtnLoader /></button>
                        :
                        <button type="submit" className="w-[100px] h-[40px] bg-dayan-gray-200 text-white rounded-[5px] text-sm shadow">اعمال</button>
                    }
                    <Link to='/p/settings/operations'>
                        <button type="button" className="w-[100px] h-[40px] bg-[#a4a4a4] text-dayan-gray-200 rounded-[5px] mr-3 text-sm shadow">بازگشت</button>
                    </Link>
                </div>

            </form>



        </div>
    )
}
